// extracted by mini-css-extract-plugin
export default {"labelsWrappers":"GiftRegistryStatusTextEdit_labelsWrappers__E3z2z"};